// ─── DEFAULT PARAMETER VALUES PER MODE ──────────────────────────────────────
// These are spread into the store initial state and reset targets.

export const DEFAULT_LINKEDIN_PARAMS = {
  postLength: 'short',
  ctaType: 'soft',
};

export const DEFAULT_CAROUSEL_PARAMS = {
  slideCount: '8',
};

export const DEFAULT_BLOG_PARAMS = {
  articleLength: '1500-2000',
  keywords: {
    primary: '',
    secondary: [
      { keyword: '', monthly_volume: null },
      { keyword: '', monthly_volume: null },
      { keyword: '', monthly_volume: null },
    ],
  },
  seoIntent: 'informational',
};

export const DEFAULT_EMAIL_PARAMS = {
  subjectStyle: 'curiosity',
  // v112: shared params
  emailLength: 'standard',         // 'breve' | 'standard' | 'approfondita'
  // v112: linkedin-newsletter specific (ignored for email-classic)
  articleStyle: 'thought-leader',  // 'thought-leader' | 'how-to' | 'trend-analysis' | 'storytelling'
  includeCompanionPost: true,
  includeCoverPrompt: false,
};

export const DEFAULT_LANDING_PARAMS = {
  headlineFormula: 'problem-solution',
  socialProof: '',
};

export const DEFAULT_ADS_PARAMS = {
  channel: 'google-search',
  adsObjective: 'conversions',
  adGroups: '1',
  adCount: '3',
  groupTopics: ['', '', ''],
};

export const DEFAULT_CASE_STUDY_PARAMS = {
  outputStyle: 'standard',
  focusArea: 'results',
};
